<script lang="ts" setup>
// ================================
// IMPORTS
// ================================
import { useI18n } from "vue-i18n"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            heading1: "Choisir un profil d'utilisation",
            exist: "Utiliser un profil existant",
            create: "Créer un nouveau profil",
        },
    },
})

// ================================
// PROPS & EMITS
// ================================
defineEmits<{
    /** Clic sur "Utiliser un profil existant" */
    "click:exist": []
    /** Clic sur "Créer un nouveau profil" */
    "click:create": []
}>()
</script>

<template>
    <div class="usage-profile-options flex flex-col gap-6">
        <h2 class="text-xl font-semibold">
            {{ t("heading1") }}
        </h2>
        <div class="flex flex-wrap justify-center gap-4">
            <BaseButton outline @click="$emit('click:exist')">
                {{ t("exist") }}
            </BaseButton>
            <BaseButton outline @click="$emit('click:create')">
                {{ t("create") }}
            </BaseButton>
        </div>
    </div>
</template>
